/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/indent */
import {
  backgroundColorParsing, getCurrentTime, getLangCookie, valueToObject,
} from 'Utils/UtilityFunctions';
import styled from 'styled-components';

import {
  maxWidth, maxMobile, maxTablet,
  retina, wMedium, xmMobile,
  wMBold,
  smMobile400,
} from 'Utils/utilsStyle';
import PeopleCardLarge from 'Components/common/components/PeopleCardLarge';
import classNames from 'classnames';
import PersonSkeleton from 'Components/common/skeleton/PersonSkeleton';
import { selectFollowedPeople, selectRecommendedPeople, selectRecommendedPeopleLoading } from 'Selector/OnboardingSelector';
import { useDispatch, useSelector } from 'react-redux';
import { peopleData, selectLoading, selectPersonLoading } from 'Selector/GlobalSearchResultsSelector';
import InfiniteScroll from 'react-infinite-scroll-component';
import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import { useEffect, useRef, useState } from 'react';
import { SearchResultsRequest } from 'Types/GlobalSearchResultsTypes';
import { actions as globalSearch } from 'Slice/GlobalSearchResultsSlice';
import ExtendedSearchLoader from 'Components/common/components/ExtendedSearchLoader';
import { actions as flurryActions } from 'Slice/HelperSlice';
import NoDataFoundComponent from './NoDataFoundComponent';

const StyleWrapper = styled.div`
.person-skeleton-loader {
  .person-box {
    @media all and (max-width: ${maxMobile}) {
      width: 73px;
      min-width: 73px;
      height: 73px;
    }
  }
  .title-box {
    @media all and (max-width: ${maxMobile}) {
      width: 69%;
      margin-top: 8px;
    }
  }
  .title-box-short {
    @media all and (max-width: ${maxMobile}) {
      margin-bottom: 0px;
    }
  }
    .btn {
      display: none;
    }
  }
.person-card {
  margin-bottom: 15px;       
  .person-item {
    margin-bottom: 0px;       
    .person-item-widget {
      .holo-svg {
        @media all and (max-width: ${maxWidth}), ${retina} {
          width: 110px;
          height: 102px;
        }
        @media all and (max-width: ${maxMobile}) {
          width: 82px;
          height: 73px;
        }
      }
      @media all and (max-width: ${maxWidth}), ${retina} {
        width: 115px;
        height: 115px;
        min-width: 115px;
      }
      @media all and (max-width: ${maxMobile}) {
        width: 85px;
        height: 83px;
        min-width: 85px;
      }
      .image-wrap-placeholder {
        .person-image-holder {
          margin: 2px;
          @media all and (max-width: ${maxMobile}) {
            margin: 1.0px 1.09px;
          }
        }
      }
      .name-wrapper {
        bottom: -2px;
        transform: translate(-52%, -36%);
        @media all and (max-width: ${maxWidth}), ${retina} {
          height: 20px;
        }
        @media all and (max-width: ${maxMobile}) {
          height: 15px;
        }
        h4 {
          font-size: 12px !important;
          @media all and (max-width: ${maxMobile}) {
            font-size: 8px !important;
          }
        }
        .anticon {
          @media all and (max-width: ${maxWidth}), ${retina} {
            min-width: 10px;
          }
        }
      }
    }
    .below-card-detail {
       &.compnayNavsOnboarding {
            display:flex;
            flex-direction:column;
            align-items:center;
          }
     .disabled-btn {
            background-color: transparent;
            border:0px;
            cursor: default;
          }
      .person-name-here {
        font-size: 18px;
        margin-top: -5px;
        margin-bottom: 0px;
        font-weight: ${wMBold};
        @media all and (max-width: ${maxWidth}), ${retina} {
          font-size: 16px;
          margin-top: -1px;
          margin-bottom: 3px;
          line-height: 19px;
        }
        @media all and (max-width: ${maxMobile}) {
          font-size: 12px;
        }
      }
      .person-designation-tip {
        font-size: 12px;
        line-height: 15px;
        @media all and (max-width: ${maxMobile}) {
          font-size: 8px;
          line-height: 10px;
        }
        .ant-tooltip {
          .ant-tooltip-content {
            .ant-tooltip-inner {
              @media all and (max-width: ${maxMobile}) {
                max-width: 150px;
                }
                @media all and (max-width: ${xmMobile}) {
                max-width: 110px;
              }
            }
            }
        }
      }
      .person-company-here {
        font-size: 13px;
        font-weight: ${wMedium};
        color: rgba(102, 121, 130, 1) !important;
        margin-bottom: 2px;
        @media all and (max-width: ${maxTablet}) {
          font-size: 12px;
        }
        @media all and (max-width: ${maxMobile}) {
          font-size: 9px;
          min-height: 24px;
        }
        @media all and (max-width: ${smMobile400}) {
          min-height: 20px;
        }
      }
      .follow-c-btn {
        @media all and (max-width: ${maxMobile}) {
          height: 24px;
        }
        .small-button-chinese {
          @media all and (max-width: ${maxMobile}) {
            padding: 4px 12px;
            font-size: 10px;
          }
        }
      }
    }
  }
}
.extended-search-loader-wrapper {
  justify-content: unset;
  @media all and (max-width: ${maxMobile}) {
    width: 160px;
  }
  .main {
    height: calc(100% - 25px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 10px 18px;
    .loader-style {
      @media all and (max-width: ${maxMobile}) {
        height: 40px;
        width: 40px;
      }
    }
    .text {
      @media all and (max-width: ${maxMobile}) {
        font-size: 12px;
        line-height: 14px;
        margin-top: 12px;
      }
    }
  }
} 
`;

type Props = {
  activeIndex: number,
  // queryData: string;
  // setQueryData: (val: string) => void
  // searchTerm: string,
  // onSearching: (val: string) => void
  // fetchMore: () => void
};

const FollowPeopleComponent = function FollowPeopleComponent(props: Props) {
  const {
    activeIndex,
    // queryData,
    // setQueryData,
    // searchedPerson,
    // setSearchedPerson,
    //  searchTerm, onSearching, fetchMore,
  } = props;
  const loading = useSelector(selectRecommendedPeopleLoading);
  const companiesLoading = useSelector(selectLoading);
  const recommendedPeople = useSelector(selectRecommendedPeople);
  const followedPeople = useSelector(selectFollowedPeople);
  const extendedSearchLoader = useSelector(selectPersonLoading);
  const peopleSection = useSelector(peopleData);
  const { persons, count } = peopleSection;
  const [queryData, setQueryData] = useState('');
  const scrollDivPeopleRef = useRef<HTMLDivElement>(null);
  const [searchPage, setSearchPage] = useState(1);
  const host = window.location.href;
  const startTime = getCurrentTime();

  const displayPeople = queryData?.length
    ? persons : [...followedPeople, ...recommendedPeople];

  const refineQuery = (line: string) => line.trim().replace(/\s+/g, ' ');
  const dispatch = useDispatch();

  useEffect(() => {
    setSearchPage(1);
    dispatch(globalSearch.globalSearchResultsResetEmpty());
  }, [queryData]);

  const onSearching = (searchText: string) => {
    setQueryData(searchText);
    if (searchText.trim().length) {
      scrollDivPeopleRef.current?.scrollTo({ top: 0 });
      if (refineQuery(searchText) === refineQuery(queryData)) return;
      if (searchText !== '') {
        const obj: SearchResultsRequest = {
          page: 1,
          query: `person:${searchText}`,
          screenName: 'onboardingFollowPeople',
          defaultLanguage: getLangCookie(),
        };
        dispatch(globalSearch.globalSearchResults(obj));
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('search_Enter_FollowPeople_Onboarding ', startTime, {
            page: 1,
            query: obj?.query,
            screenName: obj?.screenName,
            host,
          }),
        ));
      }
    } else {
      setQueryData('');
    }
  };

  const handleScroll = (): number => scrollDivPeopleRef?.current?.scrollTop || 0;

  const fetchMore = () => {
    if (!queryData) return;
    const obj: SearchResultsRequest = {
      page: searchPage + 1,
      query: `person:${queryData}`,
      screenName: 'onboardingFollowPeople',
      defaultLanguage: getLangCookie(),
    };
    dispatch(globalSearch.globalSearchResults(obj));
    setSearchPage(searchPage + 1);
  };

  const peopleCount = queryData ? count : displayPeople?.length && !loading
    ? displayPeople?.length : 0;

  useEffect(() => {
    const scrollWrapperElement = scrollDivPeopleRef.current;
    scrollWrapperElement?.addEventListener('scroll', handleScroll);
    return () => {
      scrollWrapperElement?.removeEventListener('scroll', handleScroll);
    };
  }, [scrollDivPeopleRef]);

  return (
    <StyleWrapper className="onboarding-component-mapping-container">
      <div className="title-search-div">
        <h3 className="title-for-module">Follow people to gain detailed insights (optional)</h3>
        <AlertsSearch
          onSearching={onSearching}
          placeholderText="Add your connections and prospects"
          margin="0px"
          query={queryData}
          customClass={classNames({ active: activeIndex > -1 })}
        />
      </div>
      <h6 className="title-heading">{`${queryData ? 'Searched People' : 'Recommended People'} (${peopleCount ?? 0})`}</h6>
      {displayPeople?.length ? (
        <div
          className={classNames(
            'scroll-wrapper-onboarding-company',
            {
              emptyState: !displayPeople?.length
                && !(loading || companiesLoading) && !extendedSearchLoader,
            },
          )}
          id="onboardingPeopleComponent"
          ref={scrollDivPeopleRef}
        >
          <InfiniteScroll
            hasMore
            dataLength={displayPeople?.length ?? 0}
            next={fetchMore}
            scrollableTarget="onboardingPeopleComponent"
            className="infinite-scroll-component-onboarding"
            loader={false}
          >
            <div className="onboarding-component-wrap">
              {displayPeople?.length && !loading ? displayPeople.map((person) => (
                <div className={classNames('person-card component-card')}>
                  <PeopleCardLarge
                    diameter="132px"
                    diameterXxsm="132px"
                    imageDiameter="132px"
                    tagTextPadding="0px 20px"
                    holoDiameterHeight="116px"
                    holoDiameterWidth="125px"
                    holoDiameterXxsmHeight="116px"
                    holoDiameterXxsmWidth="125px"
                    key={person?.personId}
                    showDrawerIcon={false}
                    persona={person?.archeType?.color}
                    logo={person?.personImage}
                    personName={person?.personName}
                    tag={person?.personDesignation}
                    personaType={person?.archeType?.name}
                    wrapperColor={backgroundColorParsing(person?.personalityTypes)}
                    personalityTypesColors={person?.personalityTypes}
                    hidePersonality={false}
                    follow={!person?.personAdded}
                    personAddedFlag={person?.personAdded}
                    showCheckBox={false}
                    checked={false}
                    personId={person?.personId}
                    disableNavigation
                    // addRemovePerson={false}
                    company={person?.companyName}
                  />
                </div>
              )) : null}
              {
                (loading || companiesLoading) ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(() => (
                  <div className={classNames('person-card component-card')}>
                    <PersonSkeleton
                      diameter="140px"
                      diameterSm="100px"
                    />
                  </div>
                )) : null
              }
              {extendedSearchLoader && !(loading || companiesLoading) ? (
                <ExtendedSearchLoader />
              ) : null}
            </div>
            {!displayPeople?.length && !(loading || companiesLoading) && !extendedSearchLoader && (
              <NoDataFoundComponent firstText="Could not find anyone." secondText="Please try again." />
            )}
          </InfiniteScroll>
        </div>
      ) : null}

      {!displayPeople?.length
        ? (
          <div
            className={classNames('onboarding-component-wrap', {
              emptyWrap: !displayPeople?.length
                && !(loading || companiesLoading) && !extendedSearchLoader,
            })}
          >
            {extendedSearchLoader && !(loading || companiesLoading) ? (
              <ExtendedSearchLoader />
            ) : null}
            {(loading || companiesLoading) ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(() => (
              <div className={classNames('person-card component-card')}>
                <PersonSkeleton
                  diameter="140px"
                  diameterSm="100px"
                />
              </div>
            )) : null}
            {!displayPeople?.length && !(loading || companiesLoading) && !extendedSearchLoader && (
              <NoDataFoundComponent firstText="Can’t find your Profile?" secondText="Enter your name in the search bar." />
            )}
          </div>
        )
        : null}

    </StyleWrapper>
  );
};

export default FollowPeopleComponent;
